import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "supplier-order" }

import UnfinishedOrderList from '../components/unfinished-order-list.vue';
import FinishedOrderList from '../components/finished-order-list.vue';
import { ref } from 'vue';
import { BaseTabs, BaseTabPane } from 'xrk-components';
import { useRoute, useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'supplier-order',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const pageType = ref('unfinished');
const setPageType = () => {
  if (route.query.orderNo) {
    // 清除路由上的查询参数
    router.replace({
      query: { force: Date.now() }
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseTabs), {
      onClick: setPageType,
      modelValue: pageType.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageType).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(BaseTabPane), {
          label: "未完结订单",
          name: "unfinished"
        }),
        _createVNode(_unref(BaseTabPane), {
          label: "已完结订单",
          name: "finished"
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (pageType.value === 'unfinished')
      ? (_openBlock(), _createBlock(UnfinishedOrderList, { key: 0 }))
      : _createCommentVNode("", true),
    (pageType.value === 'finished')
      ? (_openBlock(), _createBlock(FinishedOrderList, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})